import React, { useState, useEffect } from 'react';
import MobileAppPrompt from '../components/MobileAppPrompt';
import { isMobileDevice } from '../utils/mobileDetect';

// Higher Order Component pour ajouter le prompt mobile à n'importe quelle page
export function withMobilePrompt<P extends object>(
  Component: React.ComponentType<P>
): React.FC<P> {
  return (props: P) => {
    const [showMobilePrompt, setShowMobilePrompt] = useState(false);

    useEffect(() => {
      const isMobile = isMobileDevice();
      const hasSeenPrompt = sessionStorage.getItem('mobile_prompt_dismissed');
      
      if (isMobile && !hasSeenPrompt) {
        setShowMobilePrompt(true);
      }
    }, []);

    const handleContinueAnyway = () => {
      sessionStorage.setItem('mobile_prompt_dismissed', 'true');
      setShowMobilePrompt(false);
    };

    if (showMobilePrompt) {
      return <MobileAppPrompt onContinueAnyway={handleContinueAnyway} />;
    }

    return <Component {...props} />;
  };
}
